import { defineMessages } from '@jutro/locale';

export default defineMessages({
    paymentMethod: {
        id: 'ml.gateway.views.ActivityReports.mlPaymentLogAdditionalFilter.Payment Method',
        defaultMessage: 'Payment Method'
    },
    allPaymentMethods: {
        id: 'ml.gateway.views.ActivityReports.mlPaymentLogAdditionalFilter.All Payment Methods',
        defaultMessage: 'All Payment Methods'
    },
    creditDebitCard: {
        id: 'ml.gateway.views.ActivityReports.mlPaymentLogAdditionalFilter.Credit Debit Card',
        defaultMessage: 'Credit/Debit Card'
    },
    bankAccount: {
        id: 'ml.gateway.views.ActivityReports.mlPaymentLogAdditionalFilter.Bank Account',
        defaultMessage: 'Bank Account'
    },
    agencySweep: {
        id: 'ml.gateway.views.ActivityReports.mlPaymentLogAdditionalFilter.Agency Sweep',
        defaultMessage: 'Agency Sweep'
    },
    creditDebitCardCode: {
        id: 'ml.gateway.views.ActivityReports.mlPaymentLogAdditionalFilter.creditcard',
        defaultMessage: 'creditcard'
    },
    bankAccountCode: {
        id: 'ml.gateway.views.ActivityReports.mlPaymentLogAdditionalFilter.ach',
        defaultMessage: 'ach'
    },
    agencySweepCode: {
        id: 'ml.gateway.views.ActivityReports.mlPaymentLogAdditionalFilter.AgencySweep',
        defaultMessage: 'AgencySweep'
    }
});
